import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from "jwt-decode";

const ClientsTab = () => {
  const [customers, setCustomers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCoach, setSelectedCoach] = useState("");
  const [role, setRole] = useState("");
  const [coachName, setCoachName] = useState("");
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";

  useEffect(() => {
    const token = localStorage.getItem("token");
    
        if (!token) {
          setRole("unauthenticated");
          setLoading(false);
          return;
        }
    
        const decodedToken = jwtDecode(token);
    
        const { userId} = decodedToken;

    fetch(`${API_URL}account/${userId}`)
      .then((res) => res.json())
      .then((data) => {
        setRole(data.role);
        setCoachName(`${data.firstName} ${data.lastName}`);
        if (data.role !== "admin") {
          setSelectedCoach(`${data.firstName} ${data.lastName}`);
        }
      })
      .catch((error) => {
        console.error("Error checking role:", error);
        setRole("unauthenticated");
      })
      .finally(() => setLoading(false));
  }, [API_URL]);

  useEffect(() => {
    fetch(`${API_URL}customers`)
      .then(res => res.json())
      .then(data => setCustomers(data))
      .catch(err => console.error("Failed to fetch customers:", err));
  }, [API_URL]);

  
  const isAdmin = role === "admin";
  const filteredCustomers = customers.filter((customer) => {
    const fullName = `${customer.firstName} ${customer.lastName}`.toLowerCase();
    const email = (customer.email || "").toLowerCase();
    const phone = (customer.phone || "").toLowerCase();
    const search = searchTerm.toLowerCase();

    const coachToFilter = isAdmin ? selectedCoach : coachName;

    const matchesSearch =
      fullName.includes(search) ||
      email.includes(search) ||
      phone.includes(search);

    const matchesCoach = coachToFilter
      ? customer.assignedCoach === coachToFilter
      : true;

    return matchesSearch && matchesCoach;
  });

  if (loading) return <p>Loading clients... 💅</p>;

  return (
    <Container>
      <h2>{t("clientsTab.title")}</h2>
        {role === "admin" && (
        <Dropdown onChange={(e) => setSelectedCoach(e.target.value)} value={selectedCoach}>
          <option value="">{t("clientsTab.dropdownAll")}</option>
          <option value="Danielle Tremblay">Coach Danielle</option>
          <option value="Annie Carrière">Coach Annie</option>
          <option value="Céline Mailloux">Coach Céline</option>
        </Dropdown>
      )}
      <SearchInput type="text" placeholder="Search..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
      {searchTerm && (
        <p>Showing results for: <strong>"{searchTerm}"</strong></p>
      )}
      <ClientList>
        {filteredCustomers.map((client) => (
          <ClientCard key={client._id}>
            <strong>{client.firstName} {client.lastName}</strong><br/>
            📧 {client.email}<br/>
            📱 {client.phoneNumber || "N/A"} <br/>
            👩🏻‍💻 {client.assignedCoach || "N/A"}
          </ClientCard>
        ))}
      </ClientList>
    </Container>
  );
};

export default ClientsTab;

const Container = styled.div`
  padding: 2rem;
  color: #333;
`;

const SearchInput = styled.input`
  padding: 10px;
  width: 100%;
  max-width: 400px;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
`;

const ClientList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
`;

const ClientCard = styled.div`
  background:rgb(233, 231, 231);
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0px 2px 8px rgba(0,0,0,0.1);
`;

const Dropdown = styled.select`
  padding: 8px;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  margin-right: 15px;
  background-color: #fff;
`;